import React from "react";
import FoodOption from "../../../models/financing-request/FoodOption";
import { Grid, FormControlLabel, Switch } from "@material-ui/core";
import { nameof } from "../../../utilities/utilities";
import FinancingRequestStudent from "../../../models/financing-request/FinancingRequestStudent";
import { ProgramType } from "../../../models/financing-request/ProgramType";
import { SpecialNeedType } from "../../../models/special-need-type/SpecialNeedType";

interface Props {
  foodOption: FoodOption;
  student: FinancingRequestStudent;
  onChange: (e: any) => void;
}

export default function FoodItem({ foodOption, student, onChange }: Props) {
  return (
    <>
      { ((student.programType == ProgramType.Elementary && student.specialNeedType == SpecialNeedType.ExtendedProfessionalProcedure) 
          || (student.programType == ProgramType.Elementary && student.specialNeedType == SpecialNeedType.SpecialCenter)
          || student.specialNeedType == SpecialNeedType.SpecialCenter 
          || student.specialNeedType == SpecialNeedType.SpecialCenterExtendedProfessionalProcedure)
         &&
        <Grid container item xs={12} spacing={4} className="noMarginPadding">
          {/*(student.programType == ProgramType.Elementary &&
            student.specialNeedType ==
              SpecialNeedType.SpecialClassOrEducationalGroup) ||
          student.specialNeedType ==
            SpecialNeedType.ExtendedProfessionalProcedure ||
          student.specialNeedType == SpecialNeedType.SpecialCenter ||
          student.specialNeedType ==
            SpecialNeedType.SpecialCenterExtendedProfessionalProcedure ? (
            <Grid item lg={3} md={6} sm={12} xs={12}>
              <FormControlLabel
                value={foodOption.breakfast}
                checked={foodOption.breakfast}
                name={nameof<typeof foodOption>("breakfast")}
                control={<Switch color="secondary" />}
                label="Doručak"
                labelPlacement="end"
                onChange={onChange}
              />
            </Grid>
          ) : (
            <></>
          ) */} 

          {(student.programType == ProgramType.Elementary &&
            student.specialNeedType ==
              SpecialNeedType.ExtendedProfessionalProcedure) ||
          student.specialNeedType == SpecialNeedType.SpecialCenter ||
          student.specialNeedType ==
            SpecialNeedType.SpecialCenterExtendedProfessionalProcedure ? (
            <Grid item lg={3} md={6} sm={12} xs={12}>
              <FormControlLabel
                value={foodOption.lunch}
                checked={foodOption.lunch}
                name={nameof<typeof foodOption>("lunch")}
                control={<Switch color="secondary" />}
                label="Ručak"
                labelPlacement="end"
                onChange={onChange}
              />
            </Grid>
          ) : (
            <></>
          )}

          {(student.programType == ProgramType.Elementary &&
            student.specialNeedType == SpecialNeedType.SpecialCenter) ||
          student.specialNeedType ==
            SpecialNeedType.SpecialCenterExtendedProfessionalProcedure ? (
            <Grid item lg={3} md={6} sm={12} xs={12}>
              <FormControlLabel
                value={foodOption.snack}
                checked={foodOption.snack}
                name={nameof<typeof foodOption>("snack")}
                control={<Switch color="secondary" />}
                label="Užina"
                labelPlacement="end"
                onChange={onChange}
              />
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      }
    </>
  );
}
